import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@/core/services';
import { Role } from '@aphp-ema/common/auth/roles';
import { Researcher } from '@aphp-ema/common/researchers';

export interface UserRole {
  id: string;
  name: Role;
}

export const getUserRoles = async (): Promise<UserRole[]> => {
  const response = await axiosInstance.get<UserRole[]>('/researchers/me/role');
  return response.data;
};

export const getMe = async (): Promise<Researcher> => {
  const response = await axiosInstance.get<Researcher>('/researchers/me/info');
  return response.data;
};

export const useRoles = () => {
  return useQuery<UserRole[], Error>({
    queryKey: ['researchers', 'me', 'roles'],
    queryFn: getUserRoles,
    suspense: true,
    retry: (failureCount, error: unknown) => {
      // Don't retry on 401/403 errors (auth issues)
      const axiosError = error as { response?: { status?: number } };
      if (
        axiosError?.response?.status === 401 ||
        axiosError?.response?.status === 403
      ) {
        return false;
      }
      return failureCount < 2;
    },
  });
};

export const useMe = () => {
  return useQuery<Researcher, Error>({
    queryKey: ['researchers', 'me'],
    queryFn: getMe,
  });
};
